// Main entry point for InfluenceHub MVP
// Renders the App component and sets up the React application
// Includes Vite-specific setup and development tools

import './lib/routing/applyFeedbackPathFix.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { inject } from '@vercel/analytics';
import { AuthProvider } from './context/AuthContext.jsx';
import App from './App.jsx';
import { installNetworkTap } from './lib/debug/networkTap';

// Dev-only: tap Firebase Storage requests to capture 412 response body (e.g. App Check)
if (typeof window !== 'undefined') {
  installNetworkTap();
}

// Initialize Vercel Analytics for Vite
inject();

console.log('🚀 Starting React app...');
console.log('📍 Current URL:', window.location.href);

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ React Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return React.createElement('div', {
        style: {
          padding: '20px',
          backgroundColor: '#ffebee',
          color: '#c62828',
          fontFamily: 'Arial, sans-serif',
          border: '2px solid #f44336',
          borderRadius: '8px',
          margin: '20px'
        }
      }, [
        React.createElement('h1', { key: 'title' }, '❌ React App Error'),
        React.createElement('p', { key: 'error' }, `Error: ${this.state.error?.message || 'Unknown error'}`),
        React.createElement('button', {
          key: 'reload',
          onClick: () => window.location.reload(),
          style: {
            padding: '10px 20px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginTop: '10px'
          }
        }, 'Reload Page')
      ]);
    }

    return this.props.children;
  }
}

try {
  console.log('🔄 Attempting to render React app...');
  ReactDOM.createRoot(document.getElementById('root')).render(
    React.createElement(React.StrictMode, null,
      React.createElement(ErrorBoundary, null,
        React.createElement(AuthProvider, null,
          React.createElement(App)
        )
      )
    )
  );
  console.log('✅ React app rendered successfully');
} catch (error) {
  console.error('❌ Failed to render React app:', error);
  document.getElementById('root').innerHTML = `
    <div style="padding: 20px; background-color: #ffebee; color: #c62828; font-family: Arial, sans-serif; border: 2px solid #f44336; border-radius: 8px;">
      <h1>❌ React Render Failed</h1>
      <p><strong>Error:</strong> ${error.message}</p>
      <p><strong>Stack:</strong></p>
      <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;">${error.stack}</pre>
      <button onclick="window.location.reload()" style="padding: 10px 20px; background-color: #f44336; color: white; border: none; border-radius: 4px; cursor: pointer; margin-top: 10px;">
        Reload Page
      </button>
    </div>
  `;
}
